<template>
  <div style="background-color: white">
    <div v-for="(stud_data, ind) in icard_data" :key="ind">
      <div class="" style="width: 31rem">
        <v-row
          style="
            background-color: #8b3a37;
            color: white;
            border-bottom: 1px solid black;
            height: 110px;
          "
        >
          <v-col cols="12" sm="2" md="2" class="pl-6" align="right">
            <img
              :src="common_data.logo"
              style="width: 70px; height: 70px"
              alt="logo"
            />
          </v-col>
          <v-col cols="12" sm="9" md="9" align="center">
            <h6>TMV'S SCHOOL</h6>
            <h3 style="margin-top: -3px; margin-bottom: -3px">
              TILAK MAHARASHTRA VIDYALAYA
            </h3>
            <div style="font-size: 10px; margin-bottom: -3px">
              (PRE-PRIMARY, PRIMARY AND SECONDARY)
            </div>
            <b style="font-size: 10px"
              >{{ common_data.school_address }}. &nbsp;&nbsp;&nbsp;&nbsp; Tel
              No. {{ common_data.school_contact }}</b
            >
            <div
              style="
                background-color: white;
                color: #8b3a37;
                width: 70px;
                border-radius: 10px;
                font-size: 10px;
              "
            >
              CBSE Pattern
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="4" md="4" class="pb-0 pt-0 pr-0 pl-3" align="center">
            <span><b>{{stud_data.ay}}</b></span>
            <div
              v-if="stud_data.profile_photo_path"
              style="
                justify-content: center;            
                width: 130px;
                height: 130px;
                border: 3px solid black
              "
            >
              <img
              class="profile-photo"
             
                v-if="stud_data.profile_photo_path"
                :src="stud_data.profile_photo_path"                
                alt="child photo"
                height="125px"
                width="125px"
              />
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="8"
            md="8"
            align="left"
            class="pl-0 pb-0 pt-3"
            style="font-size: 13px"
          >
            <div class="row">
              <div class="col-12 pt-2">
                <span><b> Name : </b></span><span>{{ stud_data.name }}</span>
              </div>
              <div class="col-6" style="margin-top: -20px">
                <span><b> Class : </b></span><span>{{ stud_data.std }}</span>
              </div>
              <div class="col-6" style="margin-top: -20px">
                <span><b> Blood Group: </b></span
                ><span> {{ stud_data.stud_blood_group }} </span>
              </div>
              <div class="col-6" style="margin-top: -20px">
                <span><b> D.O.B. : </b></span
                ><span>{{ stud_data.stud_dob }}</span>
              </div>
              <div class="col-6" style="margin-top: -20px">
                <span><b> Gr.No. : </b></span
                ><span> {{ stud_data.grno }} </span>
              </div>
              <div class="col-2 pr-0 pl-0 ml-3" style="margin-top: -20px">
                <b> Address : </b>
              </div>
              <div
                class="col-9 pl-1 pr-7"
                style="margin-top: -20px; height: 70px"
              >
                {{ stud_data.stud_address }}
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row dense justify="end" style="margin-top: -13px">
          <v-col cols="12" sm="4" class="pt-0" align="center">
            <img
              :src="common_data.sign"
              alt="signature"
              style="width: 30px; height: 30px"
            />
            <br />
            <div style="font-size: 10px; margin-top: -6px">
              <b>Principal Sign</b>
            </div>
          </v-col>
        </v-row>
        <v-row style="background-color: #8b3a37; color: white" justify="center">          
            <div class="py-1" style="font-size: 10px"
              >EMERGENCY : {{ stud_data.emergency_contact_number }}</div
            >
        </v-row>
      </div>
    </div>
  </div>
</template>
  
  <script>
import axios from "axios";
import VueBarcode from "vue-barcode";
import QrcodeVue from "qrcode.vue";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  components: {
    barcode: VueBarcode,
    QrcodeVue,
  },
  data: () => ({
    comp_load: false,
    stud_list: null,
    radios: null,
    stud_data: null,
    child_data: null,
    icard_data: [],
    std: null,
    div: null,
    common_data: null,
    status: null,
    org_id: null,
    prn:null,
  }),
  mounted() {
  this.prn = JSON.parse(localStorage.getItem("prn"));
    this.onload();
  },

  methods: {
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
    onload() {
      const data = {
        learners: this.prn,
        for: "specific",
        usertype: "Student",
      };
      axios
        .post("/Icard/generateIcardCommon", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.icard_data = res.data.icard_data;
            this.common_data = res.data.common_data;
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          }
        })
        .catch((error) => {
          alert("Something went wrong!!!");
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
};
</script>
  
  <style scoped>
@media print {
  .profile-photo{
    height: 122px !important;
    width: 122px !important;
  }
  @page {
    margin: 0;
    size: 83mm 57mm;
  }
}
</style>
  
  